import { OrderState } from '../../../../../../types/orders';
import { Role } from '../../../../../../types/auth';

export type ValidationSubmitIntent =
  | 'save'
  | 'validate'
  | 'pending-certification'
  | null;

export type ValidationSaveInput = {
  /** Estado de la actuación leído del servidor (`network-only`) justo antes de guardar. */
  freshState: OrderState | undefined;
  /**
   * Estado de su Order gemela, también leído del servidor. El back valida la
   * transición contra el de la Order; si los dos no coinciden, manda el que
   * diga «borrador».
   */
  orderState?: OrderState | undefined;
  parentState: OrderState | undefined;
  userRole: Role | null;
  submitIntent: ValidationSubmitIntent;
};

export type ValidationSaveDecision = {
  /** `undefined` = no se toca el estado. */
  state: OrderState | undefined;
  isValidate: boolean;
};

/**
 * Qué estado manda el asistente de validación en `saveAction`.
 *
 * Un borrador (`partial`) solo sale de ahí completándose (`open`) o
 * anulándose: el servidor rechaza `partial → validated / pending-certification
 * / end` con ACTION_PARTIAL_INVALID_TARGET (decisión 2026-10-12, spec harness
 * `2026-10-12-pendientes-borradores-y-back-design.md` § 3). Como este guardado
 * viaja en la cola sin red, un rechazo descartaría la edición ENTERA; por eso,
 * si la lectura fresca dice `partial`, se manda `open` y sin marca de validada
 * sea cual sea el botón: los datos se guardan y se valida en un segundo paso.
 */
export function resolveValidationSave({
  freshState,
  orderState,
  parentState,
  userRole,
  submitIntent,
}: ValidationSaveInput): ValidationSaveDecision {
  if (freshState === OrderState.Partial || orderState === OrderState.Partial) {
    return { state: OrderState.Open, isValidate: false };
  }

  const isValidate = submitIntent === 'save' ? false : userRole !== Role.Tablet;

  const parentBlocked =
    parentState === OrderState.Annulled || parentState === OrderState.End;
  if (parentBlocked || userRole === Role.Tablet) {
    return { state: undefined, isValidate };
  }
  if (submitIntent === 'pending-certification') {
    return { state: OrderState.PendingCertification, isValidate };
  }
  if (submitIntent === 'validate') {
    return { state: OrderState.Validated, isValidate };
  }
  return { state: undefined, isValidate };
}
